@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.pinnedIcon {
  fill: $grey-30;
  margin-left: auto;
  flex-shrink: 0;
}

.timestamp {
  margin-right: 8px;
}

.metaData {
  @include md-sohne;
  color: var(--dark-60);
  display: inline-flex;
  align-items: center;

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
  }
}

.footerTimestamp {
  margin-right: 14px;
}

.unreadDot {
  top: 26px;
  left: 4px;
}

.userAndMeta {
  flex-wrap: wrap;
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
}

.itemRoot {
  .unreadDot {
    top: 20px;
    left: 3px;
  }

  &.replyItemRoot {
    padding-top: 0;
    .unreadDot {
      top: 10px;
    }
  }

  &.hasReplies:not(.isEditing) {
    padding-bottom: 1px;
  }

  &.hasReplies.isEditing {
    margin-bottom: 6px;
  }
}
